import { faPhoneOffice, faPlus } from '@fortawesome/pro-regular-svg-icons';
import type { CallTemplate } from 'bundles/connect/types';
import React, { useEffect, useState } from 'react';
import { Col, ListGroup, Row, Spinner } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';
import { getCallTemplates } from 'bundles/connect/helpers/prospect_api';
import CallTemplateRow from './call_template_row';
import CallTemplateModal from './call_template_modal';
import EmptyState from '../empty_state';

export default function CallTemplates() {
  const [templates, setTemplates] = useState<CallTemplate[]>();
  const [show, setShow] = useState(false);
  const [template, setTemplate] = useState<CallTemplate | undefined>(undefined);

  const handleShowModal = () => {
    setTemplate(undefined);
    setShow(true);
  };

  useEffect(() => {
    getCallTemplates()
      .then((response) => {
        setTemplates(response);
      });
  }, []);

  return (
    <>
      <Row className="align-items-center mb-8">
        <Col>
          <h5 className="fw-semibold">Call Templates</h5>
        </Col>
        <Col xs="auto">
          <Button
            disabled={!templates}
            icon={faPlus}
            label="Add New Template"
            type="button"
            variant="secondary"
            onClick={handleShowModal}
          />
        </Col>
      </Row>
      <ListGroup>
        {!templates && (
          <div className="text-center">
            <Spinner animation="border" variant="secondary" />
          </div>
        )}
        {templates?.length === 0 && (
          <EmptyState
            icon={faPhoneOffice}
            iconSize="2x"
            text="Call templates allow you to quickly iterate
            over your lists using predefined templates. Try setting up a new one now!"
            title="You haven't added any call templates."
          />
        )}
        {templates?.map(template => (
          <CallTemplateRow
            key={template.id}
            setShow={setShow}
            setTemplate={setTemplate}
            setTemplates={setTemplates}
            template={template}
          />
        ))}
      </ListGroup>
      <CallTemplateModal setShow={setShow} setTemplates={setTemplates} show={show} template={template} />
    </>
  );
}
